var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var HomepageHeroAngledContainer = function (_a) {
    var className = _a.className, background = _a.background, backgroundImage = _a.backgroundImage, topLeftInit = _a.topLeftInit, topLeftEnd = _a.topLeftEnd, topRightInit = _a.topRightInit, topRightEnd = _a.topRightEnd, bottomRightInit = _a.bottomRightInit, bottomRightEnd = _a.bottomRightEnd, bottomLeftInit = _a.bottomLeftInit, bottomLeftEnd = _a.bottomLeftEnd, children = _a.children, customPolygon = _a.customPolygon, customStyles = _a.customStyles;
    return (_jsx("div", __assign({ className: className, style: __assign({ background: background,
            backgroundImage: backgroundImage, clipPath: customPolygon ||
                "polygon(" + topLeftInit + "% " + topLeftEnd + "%, " + topRightInit + "% " + topRightEnd + "%, " + bottomRightInit + "% " + bottomRightEnd + "%, " + bottomLeftInit + "% " + bottomLeftEnd + "%)" }, customStyles) }, { children: children }), void 0));
};
